// extracted by mini-css-extract-plugin
export default {"markdownContent":"Conflict-markdownContent_UVqYF"};